import axios from '@/core/axios';

import { CustomerEvent, CustomerEventTypeOption } from './customer-events.types';

export class CustomerEventsService {
  listTypes(): Promise<CustomerEventTypeOption[]> {
    return axios.get<CustomerEventTypeOption[]>('/customer-events/types').then(resp => resp?.data || []);
  }

  listForCustomer(customerId: number | string): Promise<CustomerEvent[]> {
    return axios.get<CustomerEvent[]>(`/customers/${customerId}/events`).then(resp => resp?.data || []);
  }

  create(customerId: number | string, customerEvent: Partial<CustomerEvent>): Promise<CustomerEvent> {
    return axios
      .post<CustomerEvent>(`/customers/${customerId}/events`, { customer_event: customerEvent })
      .then(resp => resp?.data);
  }

  update(eventId: number | string, customerEvent: Partial<CustomerEvent>): Promise<CustomerEvent> {
    return axios
      .put<CustomerEvent>(`/customer-events/${eventId}`, { customer_event: customerEvent })
      .then(resp => resp?.data);
  }

  delete(eventId: number | string): Promise<void> {
    return axios.delete<void>(`/customer-events/${eventId}`).then(resp => resp?.data);
  }
}

export const customerEventsService = new CustomerEventsService();
